/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */
/* eslint-disable */

import '@webex/internal-plugin-encryption';
import '@webex/internal-plugin-conversation';

import {registerInternalPlugin} from '@webex/webex-core';
import {has} from 'lodash';

import EDiscovery from './ediscovery';
import Transforms from './transforms';
import config from './config';

registerInternalPlugin('ediscovery', EDiscovery, {
  config,
  payloadTransformer: {
    predicates: [
      {
        name: 'decryptReportRequest',
        direction: 'inbound',
        test(ctx, object) {
          return Promise.resolve(has(object, 'body.reportRequest'));
        },
        extract(object) {
          return Promise.resolve(object);
        },
      },
      {
        name: 'decryptReportRequestArray',
        direction: 'inbound',
        test(ctx, object) {
          return Promise.resolve(has(object, 'body[0].reportRequest'));
        },
        extract(object) {
          return Promise.resolve(object);
        },
      },
      {
        name: 'encryptReportRequest',
        direction: 'outbound',
        test(ctx, object) {
          return Promise.resolve(
            has(object, 'body.keywords') ||
              has(object, 'body.spaceNames') ||
              has(object, 'body.emails')
          );
        },
        extract(object) {
          return Promise.resolve(object);
        },
      },
      {
        name: 'decryptReportContent',
        direction: 'inbound',
        test(ctx, object) {
          return Promise.resolve(has(object, 'body.activityId'));
        },
        extract(object) {
          return Promise.resolve(object);
        },
      },
      {
        name: 'decryptReportContentArray',
        direction: 'inbound',
        test(ctx, object) {
          return Promise.resolve(has(object, 'body[0].activityId'));
        },
        extract(object) {
          return Promise.resolve(object);
        },
      },
      {
        name: 'decryptReportContentContainer',
        direction: 'inbound',
        test(ctx, object) {
          return Promise.resolve(has(object, 'body.containerId'));
        },
        extract(object) {
          return Promise.resolve(object);
        },
      },
      {
        name: 'decryptReportContentContainerArray',
        direction: 'inbound',
        test(ctx, object) {
          return Promise.resolve(has(object, 'body[0].containerId'));
        },
        extract(object) {
          return Promise.resolve(object);
        },
      },
    ],
    transforms: [
      {
        name: 'decryptReportRequest',
        direction: 'inbound',
        fn(ctx, object) {
          return Transforms.decryptReportRequest(ctx, object);
        },
      },
      {
        name: 'decryptReportRequestArray',
        direction: 'inbound',
        fn(ctx, object) {
          if (!object || !object.body) {
            return Promise.resolve();
          }

          return Promise.all(
            object.body.map((item) => ctx.transform('decryptReportRequest', {body: item}))
          );
        },
      },
      {
        name: 'encryptReportRequest',
        direction: 'outbound',
        fn(ctx, object) {
          return Transforms.encryptReportRequest(ctx, object);
        },
      },
      {
        name: 'decryptReportContent',
        direction: 'inbound',
        fn(ctx, object, reportId) {
          return Transforms.decryptReportContent(ctx, object, reportId);
        },
      },
      {
        name: 'decryptReportContentArray',
        direction: 'inbound',
        fn(ctx, object) {
          if (!object || !object.body) {
            return Promise.resolve();
          }

          // Always use the report url as this'll resolve correctly for remote reports
          return Promise.all(
            object.body.map((item) =>
              ctx.transform('decryptReportContent', {body: item}, object.options.uri)
            )
          );
        },
      },
      {
        name: 'decryptReportContentContainer',
        direction: 'inbound',
        fn(ctx, object) {
          return Transforms.decryptReportContentContainer(ctx, object);
        },
      },
      {
        name: 'decryptReportContentContainerArray',
        direction: 'inbound',
        fn(ctx, object) {
          if (!object || !object.body) {
            return Promise.resolve();
          }

          return Promise.all(
            object.body.map((item) => ctx.transform('decryptReportContentContainer', {body: item}))
          );
        },
      },
    ],
  },
});

export default EDiscovery;

// eslint-disable-next-line import/named
export {config} from './config';
export {default as ReportRequest} from './report-request';
export {EdiscoveryError, InvalidEmailAddressError} from './ediscovery-error';
